import { mapActions, mapState } from 'vuex'

export default {
  computed: {
    ...mapState('user', ['user']),

    stateFirstName: {
      get () {
        return this.user.first_name
      },

      set (value) {
        this.setUserProperty({ property: 'first_name', value })
      }
    },

    stateLastName: {
      get () {
        return this.user.last_name
      },

      set (value) {
        this.setUserProperty({ property: 'last_name', value })
      }
    },

    stateEmail: {
      get () {
        return this.user.email
      },

      set (value) {
        this.setUserProperty({ property: 'email', value })
      }
    },

    statePhone: {
      get () {
        return this.user.phone
      },

      set (value) {
        this.setUserProperty({ property: 'phone', value })
      }
    },

    stateCompany: {
      get () {
        return this.user.company
      },

      set (value) {
        this.setUserProperty({ property: 'company', value })
      }
    },

    stateInvoiceTo: {
      get () {
        return this.user.invoice_to
      },

      set (value) {
        this.setUserProperty({ property: 'invoice_to', value })
      }
    },

    statePosition: {
      get () {
        return this.user.position
      },

      set (value) {
        this.setUserProperty({property: 'position', value})
      }
    },

    stateDepartment: {
      get () {
        return this.user.department_id
      },

      set (value) {
        this.setUserProperty({property: 'department_id', value})
      }
    },

    stateDepartments: {
      get () {
        return this.user.departments.map(item => item.id ? item.id.toString() : item)
      },

      set (value) {
        this.setUserProperty({property: 'departments', value})
      }
    },

    stateRole: {
      get () {
        return this.user.role
      },

      set (value) {
        this.setUserProperty({property: 'role', value})
      }
    },

    stateCanSetEsports: {
      get () {
        return this.user.can_set_esports
      },

      set (value) {
        this.setUserProperty({property: 'can_set_esports', value})
      }
    },

    stateGender: {
      get () {
        return this.user.profile.gender
      },

      set (value) {
        this.setUserProperty({ property: 'profile.gender', value })
      }
    },

    stateDateOfBirth: {
      get () {
        return this.user.date_of_birth
      },

      set (value) {
        this.setUserProperty({ property: 'date_of_birth', value })
      }
    },

    stateWebsite: {
      get () {
        return this.user.profile.talent_website
      },

      set (value) {
        this.setUserProperty({ property: 'profile.talent_website', value })
      }
    },

    stateClubContact: {
      get () {
        return this.user.club_contact
      },

      set (value) {
        this.setUserProperty({ property: 'club_contact', value })
      }
    },

    stateManager: {
      get () {
        return this.user.profile.manager
      },

      set (value) {
        this.setUserProperty({ property: 'profile.manager', value })
      }
    },

    stateAgency: {
      get () {
        return this.user.profile.agency
      },

      set (value) {
        this.setUserProperty({ property: 'profile.agency', value })
      }
    },

    stateManagerEmail: {
      get () {
        return this.user.profile.manager_email
      },

      set (value) {
        this.setUserProperty({ property: 'profile.manager_email', value })
      }
    },

    stateTagline: {
      get () {
        return this.user.profile.tagline
      },

      set (value) {
        this.setUserProperty({ property: 'profile.tagline', value })
      }
    },

    stateFacebookLink: {
      get () {
        return this.user.profile.facebook_link
      },

      set (value) {
        this.setUserProperty({ property: 'profile.facebook_link', value })
      }
    },

    stateTwitterLink: {
      get () {
        return this.user.profile.twitter_link
      },

      set (value) {
        this.setUserProperty({ property: 'profile.twitter_link', value })
      }
    },

    stateInstagramLink: {
      get () {
        return this.user.profile.instagram_link
      },

      set (value) {
        this.setUserProperty({ property: 'profile.instagram_link', value })
      }
    },

    stateLinkedinLink: {
      get () {
        return this.user.profile.linkedin_link
      },

      set (value) {
        this.setUserProperty({ property: 'profile.linkedin_link', value })
      }
    },

    stateTiktokLink: {
      get () {
        return this.user.profile.tiktok_link
      },

      set (value) {
        this.setUserProperty({ property: 'profile.tiktok_link', value })
      }
    },

    stateYoutubeLink: {
      get () {
        return this.user.profile.youtube_link
      },

      set (value) {
        this.setUserProperty({ property: 'profile.youtube_link', value })
      }
    },

    stateFacebookCount: {
      get () {
        return this.user.profile.facebook_follower_count
      },

      set (value) {
        this.setUserProperty({ property: 'profile.facebook_follower_count', value })
      }
    },

    stateTwitterCount: {
      get () {
        return this.user.profile.twitter_follower_count
      },

      set (value) {
        this.setUserProperty({ property: 'profile.twitter_follower_count', value })
      }
    },

    stateInstagramCount: {
      get () {
        return this.user.profile.instagram_follower_count
      },

      set (value) {
        this.setUserProperty({ property: 'profile.instagram_follower_count', value })
      }
    },

    stateTiktokCount: {
      get () {
        return this.user.profile.tiktok_follower_count
      },

      set (value) {
        this.setUserProperty({ property: 'profile.tiktok_follower_count', value })
      }
    },

    stateYoutubeCount: {
      get () {
        return this.user.profile.youtube_follower_count
      },

      set (value) {
        this.setUserProperty({ property: 'profile.youtube_follower_count', value })
      }
    },

    stateDescription: {
      get () {
        return this.user.profile.description
      },

      set (value) {
        this.setUserProperty({ property: 'profile.description', value })
      }
    },

    stateLocations: {
      get () {
        return this.user.locations && this.user.locations.length ? this.user.locations.map(item => { return { id: item.id } }) : []
      },

      set (value) {
        this.setUserProperty({ property: 'locations', value })
      }
    },

    stateBasedIn: {
      get () {
        return this.user.based_in && this.user.based_in.id ? this.user.based_in.id : 0
      },

      set (value) {
        this.setUserProperty({ property: 'based_in.id', value })
      }
    },

    stateLocationRegionBasedIn: {
      get () {
        return this.user.location_region && this.user.location_region.id ? this.user.location_region.id : this.user.location_region_id ? this.user.location_region_id : 0
      },

      set (value) {
        this.setUserProperty({ property: 'location_region.id', value })
      }
    },

    stateOpportunities: {
      get () {
        return this.user.opportunities && this.user.opportunities.length ? this.user.opportunities.map(item => {
          return {id: item.id}
        }) : []
      },

      set (value) {
        this.setUserProperty({ property: 'opportunities', value })
      }
    },

    stateCommissionRate: {
      get () {
        return this.user.commission_rate
      },

      set (value) {
        this.setUserProperty({ property: 'commission_rate', value })
      }
    },

    stateDateFeaturedUntil: {
      get () {
        return this.user.profile.date_featured_until
      },

      set (value) {
        this.setUserProperty({ property: 'profile.date_featured_until', value })
      }
    },

    stateVisibility: {
      get () {
        return this.user.profile.visibility
      },

      set (value) {
        this.setUserProperty({ property: 'profile.visibility', value })
      }
    },

    stateManagement: {
      get () {
        if (!this.user.management_id) {
          return 'none'
        }

        return this.user.management_id
      },

      set (value) {
        if (value === 'none') {
          value = null
        }

        this.setUserProperty({ property: 'management_id', value })
      }
    },

    stateStaffManager: {
      get () {
        if (!this.user.manager_id) {
          return 'none'
        }

        return this.user.manager_id
      },

      set (value) {
        if (value === 'none') {
          value = null
        }

        this.setUserProperty({ property: 'manager_id', value })
      }
    },

    stateNotificationPreference: {
      get () {
        return this.user.profile.notification_preference
      },

      set (value) {
        this.setUserProperty({ property: 'profile.notification_preference', value })
      }
    },

    stateMarketSegments: {
      get () {
        return this.user.market_segments
      },

      set (value) {
        this.setUserProperty({ property: 'market_segments', value })
      }
    },

    stateTimezone: {
      get () {
        return this.user.timezone
      },

      set (value) {
        this.setUserProperty({ property: 'timezone', value })
      }
    },
    stateFirstContractId: {
      get () {
        if (Array.isArray(this.user.contracts)) {
          return this.user.contracts[0].id
        }
        return null
      },

      set (value) {
        this.setUserProperty({ property: 'contracts.0.id', value })
      }
    },
    stateContracts: {
      get () {
        return this.user.contracts
      },

      set (value) {
        this.setUserProperty({ property: 'contracts', value })
      }
    },

    stateRegion: {
      get () {
        return this.user.region_id
      },

      set (value) {
        this.setUserProperty({ property: 'region_id', value })
      }
    },

    stateDateFormat: {
      get () {
        return this.user.date_format_preference
      },

      set (value) {
        this.setUserProperty({ property: 'date_format_preference', value })
      }
    },

    stateRetired: {
      get () {
        return this.user.profile.retired
      },

      set (value) {
        this.setUserProperty({ property: 'profile.retired', value })
      }
    }
  },

  methods: {
    ...mapActions('user', ['setUserProperty'])
  }
}
